import React from 'react'
import homeImg from '../assets/home.png'
import weatherApp from '../assets/weatherApp.png'
import notesApp from '../assets/notesApp.png'
import Contact from './Contact'

const Home = () => {
  return (
    <div>
      <div
        className="w-full h-[1000px] flex items-center bg-[#fffbf3]"
        name="home"
      >
        {/* container */}
        <div className="mx-auto md:grid grid-cols-3 text-center md:p-8">
          <div className="col-span-2 mt-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              Hi, I'm{' '}
              <a
                href="./"
                className="bg-[#d7cfff] hover:bg-[#fffbf3] hover:text-[#907aff] "
              >
                Rebecca.
              </a>
            </h1>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#907aff] mb-4">
              Front-End Developer.
            </h2>
            <p className="max-w-[800px] leading-7 text-lg">
              I am based in Brisbane, Australia with experience in delivering
              end-to-end UX/UI design for software products. I'm also passionate
              about improving the lives of others through design and am
              constantly looking to learn new things everyday.
            </p>
          </div>
          <div className="items-center justify-center img-div">
            <img src={homeImg} alt="cute bear" />
          </div>
        </div>
      </div>

      {/* work section */}
      <div className="w-full h-screen mx-auto pb-16 flex flex-col bg-[#fffbf3] justify-center">
        <div className="max-w-[1200px] mx-auto p-8 flex flex-col justify-center">
          <div className="pb-4">
            <p className="text-4xl font-bold inline border-b-4 border-[#907aff]">
              Work
            </p>
            <p className="py-6">Check out some of my recent work</p>
          </div>
          <div className="group container rounded-md block justify-center items-center mx-auto">
            <div className="my-6">
              <a href="/">
                <img
                  src={weatherApp}
                  alt="weather app"
                  style={{ width: '800px' }}
                />
              </a>
            </div>
            <div className="my-6">
              <a href="/">
                <img
                  src={notesApp}
                  alt="notes app"
                  style={{ width: '800px' }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* contact section */}
      <Contact />
    </div>
  )
}

export default Home
